import Base from './base'
import urls from 'config/urls'

class Department extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.department.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.department.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.department.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.department.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.department.delete,
      data: opts
    })
  }
}

export default new Department



// WEBPACK FOOTER //
// ./src/models/department.js